import {Lang} from 'yougile-lang'
import {DealActivityDealItem, Hub} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {ChatUtils} from '@extensions/chat-utils'
import {MessageBox} from '../../message-box'

export const createOnClickDeal =
  (task?: Hub, _activity?: DealActivityDealItem) => () => {
    if (!task) {
      return
    }

    const canShow = PermissionsChecker.checkShow('ignore-departments', task, {})
    if (task && canShow) {
      ChatUtils.openChat(task, {tab: 'dealHistory'})
    } else {
      MessageBox.warn(Lang.msg.subtask.noPermissionForTask)
    }
  }
